import * as React from 'react';
import styled from 'styled-components';
import { compose, space, color, layout, typography, SpaceProps, ColorProps, LayoutProps, TypographyProps } from 'styled-system';
import { nanoid } from 'nanoid';
export type IconProps = SpaceProps & ColorProps & LayoutProps & TypographyProps;
const SvgComponent = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement> & {
  title?: any;
}>(({
  title,
  ...props
}, svgRef) => {
  const [titleId] = React.useState(() => title ? nanoid() : undefined);
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="1em" height="1em" ref={svgRef} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M14.948 13.75L18 10.59l-4.208-.65L12 6.083 10.208 9.94 6 10.59l3.052 3.16-.7 4.333L12 16.045l3.648 2.038-.7-4.332zm-.096 5.94L12 18.13l-2.852 1.56c-1.588.87-2.98-.186-2.677-2.024l.545-3.306-2.307-2.342c-1.285-1.304-.75-3.008 1.022-3.277L8.92 8.26l1.425-3.008c.4-.841 1.031-1.257 1.663-1.25.629.005 1.257.428 1.654 1.265L15.08 8.26l3.188.482c1.776.269 2.306 1.975 1.023 3.277l-2.308 2.342.545 3.306c.303 1.84-1.091 2.893-2.677 2.025z" clipRule="evenodd" /></svg>;
});
export const IconOtherStar = styled(SvgComponent)<IconProps>({
  flex: 'none',
  verticalAlign: 'middle'
}, compose(space, color, layout, typography));